import { ReactNode } from "react";
// @mui
import { Box, Link } from "@mui/material";
//
import Breadcrumbs, { Props as BreadcrumbsProps } from "./Breadcrumbs";

// ----------------------------------------------------------------------

interface Props extends BreadcrumbsProps {
  action?: ReactNode;
  heading?: string;
  moreLink?: string | string[];
  loading?: boolean;
}

export default function HeaderBreadcrumbs({
  links,
  action,
  heading,
  loading,
  moreLink = "" || [],
  sx,
  ...other
}: Props) {
  return (
    <Box sx={{ ...sx }}>
      <Box>
        {typeof moreLink === "string" ? (
          <Link href={moreLink} target="_blank" rel="noopener" variant="body2">
            {moreLink}
          </Link>
        ) : (
          moreLink.map((href) => (
            <Link
              noWrap
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              rel="noopener"
              sx={{ display: "table" }}
            >
              {href}
            </Link>
          ))
        )}
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ flexGrow: 1 }}>
          <Breadcrumbs links={links} {...other} />
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>
    </Box>
  );
}
